import { render, staticRenderFns } from "./indexHexin.vue?vue&type=template&id=0c2d8ef0&scoped=true&"
import script from "./indexHexin.vue?vue&type=script&lang=js&"
export * from "./indexHexin.vue?vue&type=script&lang=js&"
import style1 from "./indexHexin.vue?vue&type=style&index=1&id=0c2d8ef0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2d8ef0",
  null
  
)

export default component.exports